module.exports = __webpack_public_path__ + "static/img/solve21.5754788.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve21.svg
// module id = JlvO
// module chunks = 0